import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import AllSteps from '../components/common/AllSteps';
import Breadcrumb from '../components/common/Breadcrumb';
import Header from '../components/common/Header';
import Notification from '../components/common/Notification';
import Sidebar from '../components/common/Sidebar';

const Dashboard = () => {
    const { pathname } = useLocation();
    let step = {};
    step = AllSteps.find((data) => data.step.path === pathname);
    const { user } = useSelector((state) => state.authReducer);

    const { Component } = step.step;

    const [notification, setNotification] = useState({
        open: false,
        type: '',
        message: '',
        timeout: 5000,
    });

    const createNotification = (type, message) =>
        setNotification({ ...notification, open: true, type, message });
    const closeNotification = () =>
        setNotification({ ...notification, open: false, type: '', message: '' });

    return (
        <div className='flex w-100 h-100'>
            <Header />
            <div className='flex w-100'>
                <Sidebar user={user} />
                <div className='flex column w-100 content_box'>
                    <Breadcrumb user={user} createNotification={createNotification} />
                    <Component createNotification={createNotification} />
                    <Notification {...notification} onClose={closeNotification} />
                </div>
            </div>
        </div>
    );
};
export default Dashboard;
